export const translations = {
  en: {
    title: "Calculate Quantity",
    productLabel: "Product",
    selectPlaceholder: "Select an option...",
    applicationLabel: "Application",
    surfaceLabel: "Surface area",
    surfaceLabelPlaceholder: "Enter the surface area",
    thicknessLabel: "Thickness",
    thicknessLabelPlaceholder: "Enter thickness",
    submitButton: "Submit",
    resultsHeader: "You need:",
    resultLabels: {
      bulkDensity: "Bulk density kg",
      thermalCond: "Thermal conductivity, W / mK",
      thermalRes: "Thermal Resistance, R, m²K/W",
      insulation: "Insulation kg",
      kgPackage: "Kg per package",
      product: "Product",
      total: "Total Packages",
    },
    invalidInput: "Invalid Input",
    taxNumber: "Tax Number",
    deliveryAddress: "Delivery Address",
    sameAddress: "Same Address",
    firstName: "First Name",
    lastName: "Last Name",
    company: "Company",
    email: "Email",
    phoneNumber: "Phone Number",
    address: "Address",
    contactDetails: "Contact Details",
    quantity: "Quantity",
    etexClassification: "I am",
    country: "Country",
    state: "State/Region",
    zip: "ZIP Code",
    city: "City",
    language: "Language",
    optInConsentLabel:
      "By clicking this box, you agree to receive e-marketing communications about Ursa and complementary Etex products. Your personal data will be processed in line with our Privacy Notice. Note that you can withdraw your consent at any time. By submitting this form, you agree that your personal data will be processed to provide the information requested, in line with our Privacy Notice.",
    optInConsentForm:
      "By submitting this form, you agree that your personal data will be processed to provide the information requested, in line with our Privacy Notice.",
    submitting: "Submitting...",
    submissionSuccess: "Form submitted successfully!",
    submissionError: "There was an error submitting the form.",
    networkError: "Network error. Please try again later.",
    productQuantity: "Product + Quantity",
  },
  de: {
    title: "Menge berechnen",
    productLabel: "Produkt",
    selectPlaceholder: "Wählen Sie eine Option...",
    applicationLabel: "Anwendung",
    surfaceLabel: "Oberfläche",
    surfaceLabelPlaceholder: "Geben Sie die Oberfläche ein",
    thicknessLabel: "Dicke",
    thicknessLabelPlaceholder: "Dicke eingeben",
    submitButton: "Einreichen",
    resultsHeader: "Sie benötigen:",
    resultLabels: {
      bulkDensity: "Rohdichte kg",
      thermalCond: "Wärmeleitfähigkeit, W / mK",
      thermalRes: "Wärmewiderstand, R, m²K/W",
      insulation: "Isolierung kg",
      kgPackage: "Kg pro Paket",
      product: "Produkt",
      total: "Gesamt Pakete",
    },
    invalidInput: "Ungültige Eingabe",
    taxNumber: "Steuernummer",
    deliveryAddress: "Lieferadresse",
    sameAddress: "Gleiche Adresse",
    firstName: "Vorname",
    lastName: "Nachname",
    company: "Firma",
    email: "E-Mail",
    phoneNumber: "Telefonnummer",
    address: "Adresse",
    contactDetails: "Kontaktdaten",
    quantity: "Menge",
    etexClassification: "Ich bin",
    country: "Land",
    state: "Bundesland/Region",
    zip: "PLZ",
    city: "Stadt",
    language: "Sprache",
    optInConsentLabel:
      "Durch Anklicken dieses Feldes erklären Sie sich damit einverstanden, E-Marketing-Mitteilungen über Ursa und ergänzende Produkte von Etex zu erhalten. Ihre personenbezogenen Daten werden in Übereinstimmung mit unserer Datenschutzerklärung verarbeitet. Bitte beachten Sie, dass Sie Ihre Einwilligung jederzeit widerrufen können.",
    optInConsentForm:
      "Durch Absenden dieses Formulars erklären Sie sich damit einverstanden, dass Ihre personenbezogenen Daten gemäß unserer Datenschutzerklärung verarbeitet werden, um die angeforderten Informationen bereitzustellen.",
    submitting: "Einreichen...",
    submissionSuccess: "Formular erfolgreich übermittelt!",
    submissionError: "Beim Absenden des Formulars ist ein Fehler aufgetreten.",
    networkError: "Netzwerkfehler. Bitte versuchen Sie es später erneut.",
    productQuantity: "Produkt + Menge",
  },
  es: {
    title: "Calcular Cantidad",
    productLabel: "Producto",
    selectPlaceholder: "Seleccione una opción...",
    applicationLabel: "Aplicación",
    surfaceLabel: "Superficie",
    surfaceLabelPlaceholder: "Ingrese el área de superficie",
    thicknessLabel: "Espesor",
    thicknessLabelPlaceholder: "Ingrese el espesor",
    submitButton: "Enviar",
    resultsHeader: "Usted necesita:",
    resultLabels: {
      bulkDensity: "Densidad aparente kg",
      thermalCond: "Conductividad térmica, W / mK",
      thermalRes: "Resistencia térmica, R, m²K/W",
      insulation: "Aislamiento kg",
      kgPackage: "Kg por paquete",
      product: "Producto",
      total: "Total de paquetes",
    },
    invalidInput: "Entrada inválida",
    taxNumber: "Número de IVA",
    deliveryAddress: "Dirección de entrega",
    sameAddress: "Misma dirección",
    firstName: "Nombre",
    lastName: "Apellido",
    company: "Empresa",
    email: "Correo electrónico",
    phoneNumber: "Número de teléfono",
    address: "Dirección",
    contactDetails: "Detalles de contacto",
    quantity: "Cantidad",
    etexClassification: "Yo soy",
    country: "País",
    state: "Provincia/Región",
    zip: "Código Postal",
    city: "Ciudad",
    language: "Idioma",
    optInConsentLabel:
      "Al hacer clic en esta casilla, muestra su conformidad para recibir comunicaciones de marketing electrónico sobre Ursa y productos complementarios de Etex. Sus datos personales se procesarán ajustándose a nuestro Aviso de privacidad. Tenga en cuenta que puede retirar su consentimiento en cualquier momento.",
    optInConsentForm:
      "Al enviar este formulario, está de acuerdo con el tratamiento de sus datos personales para proporcionar la información solicitada, ajustándose a nuestro Aviso de privacidad.",
    submitting: "Enviando...",
    submissionSuccess: "¡Formulario enviado con éxito!",
    submissionError: "Hubo un error al enviar el formulario.",
    networkError: "Error de red. Por favor, inténtelo de nuevo más tarde.",
    productQuantity: "Producto + Cantidad",
  },
  fr: {
    title: "Calculer la quantité",
    productLabel: "Produit",
    selectPlaceholder: "Sélectionnez une option...",
    applicationLabel: "Application",
    surfaceLabel: "Surface",
    surfaceLabelPlaceholder: "Entrez la surface",
    thicknessLabel: "Épaisseur",
    thicknessLabelPlaceholder: "Entrez l'épaisseur",
    submitButton: "Soumettre",
    resultsHeader: "Vous avez besoin de :",
    resultLabels: {
      bulkDensity: "Densité apparente kg",
      thermalCond: "Conductivité thermique, W / mK",
      thermalRes: "Résistance thermique, R, m²K/W",
      insulation: "Isolation kg",
      kgPackage: "Kg par paquet",
      product: "Produit",
      total: "Total des paquets",
    },
    invalidInput: "Entrée invalide",
    taxNumber: "Numéro de TVA",
    deliveryAddress: "Adresse de livraison",
    sameAddress: "Même adresse",
    firstName: "Prénom",
    lastName: "Nom",
    company: "Société",
    email: "Email",
    phoneNumber: "Numéro de téléphone",
    address: "Adresse",
    contactDetails: "Coordonnées",
    quantity: "Quantité",
    etexClassification: "Je suis",
    country: "Pays",
    state: "Région",
    zip: "Code postal",
    city: "Ville",
    language: "Langue",
    optInConsentLabel:
      "En cliquant sur cette case, vous acceptez de recevoir des communications e-marketing sur Ursa et sur les produits complémentaires d'Etex. Vos données à caractère personnel seront traitées conformément à notre déclaration de confidentialité. Veuillez noter que vous pouvez retirer votre consentement à tout moment.",
    optInConsentForm:
      "En soumettant ce formulaire, vous acceptez que vos données à caractère personnel soient traitées pour fournir les informations demandées, conformément à notre déclaration de confidentialité.",
    submitting: "Soumission...",
    submissionSuccess: "Formulaire soumis avec succès !",
    submissionError:
      "Une erreur s'est produite lors de la soumission du formulaire.",
    networkError: "Erreur réseau. Veuillez réessayer plus tard.",
    productQuantity: "Produit + Quantité",
  },
  nl: {
    title: "Hoeveelheid berekenen",
    productLabel: "Product",
    selectPlaceholder: "Selecteer een optie...",
    applicationLabel: "Toepassing",
    surfaceLabel: "Oppervlakte",
    surfaceLabelPlaceholder: "Voer het oppervlak in",
    thicknessLabel: "Dikte",
    thicknessLabelPlaceholder: "Voer de dikte in",
    submitButton: "Verzenden",
    resultsHeader: "U heeft nodig:",
    resultLabels: {
      bulkDensity: "Bulkdichtheid kg",
      thermalCond: "Thermische geleidbaarheid, W / mK",
      thermalRes: "Thermische weerstand, R, m²K/W",
      insulation: "Isolatie kg",
      kgPackage: "Kg per pakket",
      product: "Product",
      total: "Totaal pakketten",
    },
    invalidInput: "Ongeldige invoer",
    taxNumber: "Btw-nummer",
    deliveryAddress: "Bezorgadres",
    sameAddress: "Zelfde adres",
    firstName: "Voornaam",
    lastName: "Achternaam",
    company: "Bedrijf",
    email: "E-mail",
    phoneNumber: "Telefoonnummer",
    address: "Adres",
    contactDetails: "Contactgegevens",
    quantity: "Hoeveelheid",
    etexClassification: "Ik ben",
    country: "Land",
    state: "Staat/Regio",
    zip: "Postcode",
    city: "Stad",
    language: "Taal",
    optInConsentLabel:
      "Door op dit vakje te klikken, gaat u ermee akkoord om e-marketingberichten over Ursa en aanvullende Etex-producten te ontvangen. Uw persoonsgegevens worden verwerkt in overeenstemming met onze Privacyverklaring. U kunt uw toestemming op elk moment intrekken.",
    optInConsentForm:
      "Door dit formulier in te dienen, gaat u ermee akkoord dat uw persoonsgegevens worden verwerkt om de gevraagde informatie te verstrekken, in overeenstemming met onze Privacyverklaring.",
    submitting: "Verzenden...",
    submissionSuccess: "Formulier succesvol verzonden!",
    submissionError:
      "Er is een fout opgetreden bij het verzenden van het formulier.",
    networkError: "Netwerkfout. Probeer het later opnieuw.",
    productQuantity: "Product + Hoeveelheid",
  },
  pt: {
    title: "Calcular Quantidade",
    productLabel: "Produto",
    selectPlaceholder: "Selecione uma opção...",
    applicationLabel: "Aplicação",
    surfaceLabel: "Área de superfície",
    surfaceLabelPlaceholder: "Digite a área de superfície",
    thicknessLabel: "Espessura",
    thicknessLabelPlaceholder: "Digite a espessura",
    submitButton: "Enviar",
    resultsHeader: "Você precisa de:",
    resultLabels: {
      bulkDensity: "Densidade aparente kg",
      thermalCond: "Condutividade térmica, W / mK",
      thermalRes: "Resistência térmica, R, m²K/W",
      insulation: "Isolamento kg",
      kgPackage: "Kg por pacote",
      product: "Produto",
      total: "Total de pacotes",
    },
    invalidInput: "Entrada inválida",
    taxNumber: "Número fiscal",
    deliveryAddress: "Endereço de entrega",
    sameAddress: "Mesmo endereço",
    firstName: "Nome",
    lastName: "Sobrenome",
    company: "Empresa",
    email: "E-mail",
    phoneNumber: "Número de telefone",
    address: "Endereço",
    contactDetails: "Detalhes de contato",
    quantity: "Quantidade",
    etexClassification: "Eu sou",
    country: "País",
    state: "Estado/Região",
    zip: "Código postal",
    city: "Cidade",
    language: "Idioma",
    optInConsentLabel:
      "Ao marcar esta caixa, você concorda em receber comunicações de marketing eletrônico sobre a Ursa e produtos complementares da Etex. Seus dados pessoais serão processados de acordo com o nosso Aviso de Privacidade. Observe que você pode retirar seu consentimento a qualquer momento.",
    optInConsentForm:
      "Ao enviar este formulário, você concorda que seus dados pessoais serão processados para fornecer as informações solicitadas, de acordo com nosso Aviso de Privacidade.",
    submitting: "Enviando...",
    submissionSuccess: "Formulário enviado com sucesso!",
    submissionError: "Houve um erro ao enviar o formulário.",
    networkError: "Erro de rede. Tente novamente mais tarde.",
    productQuantity: "Produto + Quantidade",
  },
  pl: {
    title: "Oblicz ilość",
    productLabel: "Produkt",
    selectPlaceholder: "Wybierz opcję...",
    applicationLabel: "Zastosowanie",
    surfaceLabel: "Powierzchnia",
    surfaceLabelPlaceholder: "Wprowadź powierzchnię",
    thicknessLabel: "Grubość",
    thicknessLabelPlaceholder: "Wprowadź grubość",
    submitButton: "Zatwierdź",
    resultsHeader: "Potrzebujesz:",
    resultLabels: {
      bulkDensity: "Gęstość objętościowa kg",
      thermalCond: "Przewodność cieplna, W / mK",
      thermalRes: "Opór cieplny, R, m²K/W",
      insulation: "Izolacja kg",
      kgPackage: "Kg na paczkę",
      product: "Produkt",
      total: "Łączna liczba paczek",
    },
    invalidInput: "Nieprawidłowe dane",
    taxNumber: "Numer NIP",
    deliveryAddress: "Adres dostawy",
    sameAddress: "Ten sam adres",
    firstName: "Imię",
    lastName: "Nazwisko",
    company: "Firma",
    email: "Email",
    phoneNumber: "Numer telefonu",
    address: "Adres",
    contactDetails: "Dane kontaktowe",
    quantity: "Ilość",
    etexClassification: "Jestem",
    country: "Kraj",
    state: "Województwo/Region",
    zip: "Kod pocztowy",
    city: "Miasto",
    language: "Język",
    optInConsentLabel:
      "Zaznaczając to pole, zgadzasz się na otrzymywanie komunikatów e-marketingowych dotyczących Ursa i komplementarnych produktów Etex. Twoje dane osobowe będą przetwarzane zgodnie z naszą Polityką prywatności. Możesz wycofać zgodę w dowolnym momencie. Przesyłając ten formularz, zgadzasz się na przetwarzanie danych w celu realizacji zapytania, zgodnie z naszą Polityką prywatności.",
    optInConsentForm:
      "Przesyłając ten formularz, zgadzasz się, że Twoje dane osobowe będą przetwarzane w celu dostarczenia żądanych informacji, zgodnie z naszą Informacją o ochronie prywatności.",
    submitting: "Wysyłanie...",
    submissionSuccess: "Formularz został pomyślnie wysłany!",
    submissionError: "Wystąpił błąd podczas wysyłania formularza.",
    networkError: "Błąd sieci. Spróbuj ponownie później.",
    productQuantity: "Produkt + Ilość",
  },
  hu: {
    title: "Mennyiség kiszámítása",
    productLabel: "Termék",
    selectPlaceholder: "Válasszon egy opciót...",
    applicationLabel: "Alkalmazás",
    surfaceLabel: "Felület",
    surfaceLabelPlaceholder: "Adja meg a felületet",
    thicknessLabel: "Vastagság",
    thicknessLabelPlaceholder: "Adja meg a vastagságot",
    submitButton: "Elküldés",
    resultsHeader: "Szüksége van:",
    resultLabels: {
      bulkDensity: "Térfogatsűrűség kg",
      thermalCond: "Hővezető képesség, W / mK",
      thermalRes: "Hőellenállás, R, m²K/W",
      insulation: "Szigetelés kg",
      kgPackage: "Kg/csomag",
      product: "Termék",
      total: "Összes csomag",
    },
    invalidInput: "Érvénytelen adat",
    taxNumber: "Adószám",
    deliveryAddress: "Szállítási cím",
    sameAddress: "Ugyanaz a cím",
    firstName: "Keresztnév",
    lastName: "Vezetéknév",
    company: "Cég",
    email: "Email",
    phoneNumber: "Telefonszám",
    address: "Cím",
    contactDetails: "Kapcsolattartási adatok",
    quantity: "Mennyiség",
    etexClassification: "Én vagyok",
    country: "Ország",
    state: "Állam/Régió",
    zip: "Irányítószám",
    city: "Város",
    language: "Nyelv",
    optInConsentLabel:
      "A négyzet bejelölésével hozzájárul, hogy e-marketing kommunikációkat kapjon a Ursa és az Etex kiegészítő termékeiről. Személyes adatait az Adatvédelmi Tájékoztatónknak megfelelően kezeljük. Hozzájárulását bármikor visszavonhatja. A űrlap elküldésével elfogadja, hogy adatait a kért információ biztosítása céljából kezeljük.",
    optInConsentForm:
      "Az űrlap elküldésével Ön beleegyezik abba, hogy személyes adatait a kért információk biztosítása érdekében az Adatvédelmi nyilatkozatunkkal összhangban feldolgozzuk.",
    submitting: "Elküldés...",
    submissionSuccess: "Az űrlapot sikeresen elküldtük!",
    submissionError: "Hiba történt az űrlap elküldése során.",
    networkError: "Hálózati hiba. Kérjük, próbálja meg később.",
    productQuantity: "Termék + Mennyiség",
  },
  cs: {
    title: "Spočítat množství",
    productLabel: "Produkt",
    selectPlaceholder: "Vyberte možnost...",
    applicationLabel: "Aplikace",
    surfaceLabel: "Plocha",
    surfaceLabelPlaceholder: "Zadejte plochu",
    thicknessLabel: "Tloušťka",
    thicknessLabelPlaceholder: "Zadejte tloušťku",
    submitButton: "Odeslat",
    resultsHeader: "Potřebujete:",
    resultLabels: {
      bulkDensity: "Objemová hmotnost kg",
      thermalCond: "Tepelná vodivost, W / mK",
      thermalRes: "Tepelný odpor, R, m²K/W",
      insulation: "Izolace kg",
      kgPackage: "Kg na balení",
      product: "Produkt",
      total: "Celkem balení",
    },
    invalidInput: "Neplatný vstup",
    taxNumber: "DIČ",
    deliveryAddress: "Doručovací adresa",
    sameAddress: "Stejná adresa",
    firstName: "Jméno",
    lastName: "Příjmení",
    company: "Společnost",
    email: "Email",
    phoneNumber: "Telefonní číslo",
    address: "Adresa",
    contactDetails: "Kontaktní údaje",
    quantity: "Množství",
    etexClassification: "Jsem",
    country: "Země",
    state: "Stát/Region",
    zip: "PSČ",
    city: "Město",
    language: "Jazyk",
    optInConsentLabel:
      "Zaškrtnutím tohoto políčka souhlasíte s přijímáním e-marketingových sdělení o Ursa a doplňkových produktech Etex. Vaše osobní údaje budou zpracovány v souladu s naším Oznámením o ochraně soukromí. Svůj souhlas můžete kdykoli odvolat. Odesláním tohoto formuláře souhlasíte se zpracováním osobních údajů za účelem poskytnutí požadovaných informací.",
    optInConsentForm:
      "Odesláním tohoto formuláře souhlasíte s tím, že vaše osobní údaje budou zpracovány za účelem poskytnutí požadovaných informací v souladu s naším oznámením o ochraně osobních údajů.",
    submitting: "Odesílání...",
    submissionSuccess: "Formulář byl úspěšně odeslán!",
    submissionError: "Při odesílání formuláře došlo k chybě.",
    networkError: "Chyba sítě. Zkuste to prosím později.",
    productQuantity: "Produkt + Množství",
  },
  it: {
    title: "Calcola la quantità",
    productLabel: "Prodotto",
    selectPlaceholder: "Seleziona un'opzione...",
    applicationLabel: "Applicazione",
    surfaceLabel: "Superficie",
    surfaceLabelPlaceholder: "Inserisci la superficie",
    thicknessLabel: "Spessore",
    thicknessLabelPlaceholder: "Inserisci lo spessore",
    submitButton: "Invia",
    resultsHeader: "Hai bisogno di:",
    resultLabels: {
      bulkDensity: "Densità apparente kg",
      thermalCond: "Conduttività termica, W / mK",
      thermalRes: "Resistenza termica, R, m²K/W",
      insulation: "Isolamento kg",
      kgPackage: "Kg per confezione",
      product: "Prodotto",
      total: "Totale confezioni",
    },
    invalidInput: "Dati non validi",
    taxNumber: "Partita IVA",
    deliveryAddress: "Indirizzo di consegna",
    sameAddress: "Stesso indirizzo",
    firstName: "Nome",
    lastName: "Cognome",
    company: "Azienda",
    email: "Email",
    phoneNumber: "Numero di telefono",
    address: "Indirizzo",
    contactDetails: "Dettagli di contatto",
    quantity: "Quantità",
    etexClassification: "Io sono",
    country: "Paese",
    state: "Stato/Regione",
    zip: "CAP",
    city: "Città",
    language: "Lingua",
    optInConsentLabel:
      "Selezionando questa casella, acconsenti a ricevere comunicazioni di marketing elettronico su Ursa e prodotti complementari Etex. I tuoi dati personali saranno trattati secondo la nostra Informativa sulla privacy. Puoi revocare il consenso in qualsiasi momento. Inviando questo modulo, accetti che i tuoi dati personali siano trattati per fornire le informazioni richieste, in linea con la nostra Informativa sulla privacy.",
    optInConsentForm:
      "Inviando questo modulo, l'utente accetta che i suoi dati personali vengano trattati per fornire le informazioni richieste, in linea con la nostra Informativa sulla privacy.",
    submitting: "Invio in corso...",
    submissionSuccess: "Modulo inviato con successo!",
    submissionError: "Si è verificato un errore durante l'invio del modulo.",
    networkError: "Errore di rete. Riprova più tardi.",
    productQuantity: "Prodotto + Quantità",
  },
};
